if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelector('.product-media-modal__toggle').addEventListener('click', () => this.media_hide());
      }

      hide() {
        // super.hide();
      }
      media_hide() {
        super.hide();
      }
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (activeMedia) {
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          if (container && typeof activeMedia.width === 'number') {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent();
        }

        const viewer = this.querySelector('#viewer');
        if (viewer && typeof viewer.setCurrentImageById === 'function') {
          viewer.setCurrentImageById(this.openedBy.getAttribute('data-media-id'));
        }
      }
    }
  );
}
